"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var base_1 = require("./base");
var Circle = /** @class */ (function (_super) {
    __extends(Circle, _super);
    function Circle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._reservedAttr = ["r"];
        _this._geometryKeys = ["x", "y", "r"];
        return _this;
    }
    Circle.prototype.renderElement = function (node, d, i, g, h) {
        if (this._isDirty(["_x", "_y", "_anchor", "r"])) {
            var x = void 0;
            var y = void 0;
            var pos = {
                x: this._getGeometry("_x", true, d, i, g),
                y: this._getGeometry("_y", false, d, i, g),
            };
            // radius
            var radius = void 0;
            if (this._options.r) {
                console.warn("Please use _r for Circle radius.");
                radius = this._getGeometry("r", true, d, i, g);
            }
            else {
                radius = this._getGeometry("_r", true, d, i, g);
            }
            // anchor
            var anchor = h.op("_anchor");
            if (anchor & 16 /* Left */) {
                x = pos.x + radius;
            }
            else if (anchor & 32 /* Center */) {
                x = pos.x;
            }
            else if (anchor & 64 /* Right */) {
                x = pos.x - radius;
            }
            if (anchor & 2 /* Top */) {
                y = pos.y + radius;
            }
            else if (anchor & 4 /* Middle */) {
                y = pos.y;
            }
            else if (anchor & 8 /* Bottom */) {
                y = pos.y - radius;
            }
            node.attr("cx", x).attr("cy", y).attr("r", radius);
        }
    };
    Circle.prototype.maxIntrinsicSize = function (horizontal, useComputedSize) {
        var _this = this;
        if (useComputedSize === void 0) { useComputedSize = false; }
        var startOp = horizontal ? "x" : "y";
        var size = useComputedSize ? this._computedSize : this._intrinsicSize;
        return _.max(size.map(function (x, i) {
            var p = x[startOp] || 0;
            var r = x.r || 0;
            var anchor = _this._cachedAnchor[i];
            if (horizontal) {
                return anchor & 16 /* Left */ ? p + 2 * r :
                    anchor & 32 /* Center */ ? p + r :
                        p;
            }
            else {
                return anchor & 2 /* Top */ ? p + 2 * r :
                    anchor & 4 /* Middle */ ? p + r :
                        p;
            }
        }));
    };
    Circle.nodeName = "circle";
    return Circle;
}(base_1.BaseElement));
exports.Circle = Circle;
//# sourceMappingURL=circle.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/element/circle.js
// module id = 1132
// module chunks = 0 1